import ErrorFallback from 'Components/ErrorFallback'
import AuthoritySelectionRequired from 'Services/common/Features/Authority/Components/AuthoritySelectionRequired'
import {
  SalesPointCreatePage,
  SalesPointEditPage,
  SalesPointListPage
} from 'Services/ServiceProviderManagement/Features/SalesPoint/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

export function SalesPointRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<SalesPointListPage />} />
        <Route element={<AuthoritySelectionRequired backButtonFallbackPath="./" />}>
          <Route path="create" element={<SalesPointCreatePage />} />
          <Route path=":id/edit" element={<SalesPointEditPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}
